import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FilledArrowLeftGlyph = /*#__PURE__*/createElement("g", {
  id: "filled_arrow_left"
}, /*#__PURE__*/createElement("path", {
  d: "M51,19.8c0-1.1-0.6-1.4-1.4-0.6L28.3,40.4c-0.8,0.8-0.8,2,0,2.8l21.3,21.5c0.8,0.8,1.4,0.5,1.4-0.6V19.8z"
}));
const FilledArrowLeft = createSvg({
  name: 'filled_arrow_left',
  path: FilledArrowLeftGlyph
});

export default FilledArrowLeft;
export { FilledArrowLeftGlyph };
